import { useRefreshCollection } from 'json-api-hooks';
import React from 'react';

import ResourceForm, { FormFieldDefinition, ResourceFormProps } from '../components/./Form/ResourceForm';
import { InputType } from '../components/./Form/types';
import useSnackbar from '../hooks/useSnackbar';

const formFields: FormFieldDefinition<'visits/bulk'>[] = [
  {
    attribute: 'addressIds',
    required: true,
    type: InputType.Hidden,
    multiple: true,
  },
  {
    attribute: 'result',
    required: true,
    label: 'Resultaat',
    type: InputType.Select,
    options: [
      { key: 'come_back', label: 'Geen tijd' },
      { key: 'no_conversation', label: 'Geen interesse' },
      { key: 'no_dutch', label: 'Spreekt geen Nederlands' },
      { key: 'not_a_home', label: 'Geen woonhuis' },
      { key: 'not_at_home', label: 'Niet thuis' },
    ],
  },
];

const BulkVisitForm = (props: Partial<ResourceFormProps<'visits/bulk'>>) => {
  const refreshCollection = useRefreshCollection();
  const showSnackbar = useSnackbar();

  const handleSuccess = () => {
    showSnackbar('Bedankt voor je bijdrage!');
    refreshCollection('addresses');
    props.onClose?.();
  };

  return (
    <ResourceForm fields={formFields} submitLabel="Opslaan" type="visits/bulk" onSuccess={handleSuccess} {...props} />
  );
};

export default BulkVisitForm;
